import { render, staticRenderFns } from "./SlotCheckboxList.vue?vue&type=template&id=fb881c92&"
import script from "./SlotCheckboxList.vue?vue&type=script&lang=js&"
export * from "./SlotCheckboxList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCardActions,VCheckbox})


/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb881c92')) {
      api.createRecord('fb881c92', component.options)
    } else {
      api.reload('fb881c92', component.options)
    }
    module.hot.accept("./SlotCheckboxList.vue?vue&type=template&id=fb881c92&", function () {
      api.rerender('fb881c92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/equipment/components/SlotCheckboxList.vue"
export default component.exports